import React, { useContext } from 'react';
import { LanguageContext } from '../App';
import { SaveIcon, BellIcon, GlobeIcon, UserIcon, ShieldIcon, CreditCardIcon } from 'lucide-react';
export const Settings: React.FC = () => {
  const {
    language
  } = useContext(LanguageContext);
  return <div className="space-y-6" data-id="element-1271">
      <div className="flex justify-between items-center" data-id="element-1272">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-1273">
          {language === 'en' ? 'Settings' : 'الإعدادات'}
        </h2>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1274">
        <div className="grid grid-cols-1 md:grid-cols-4" data-id="element-1275">
          <div className="p-6 border-r border-gray-200" data-id="element-1276">
            <nav className="space-y-1" data-id="element-1277">
              <button className="flex items-center px-3 py-2 w-full text-sm font-medium rounded-md bg-congress-blue-50 text-congress-blue-700" data-id="element-1278">
                <GlobeIcon size={18} className="mr-3" data-id="element-1279" />
                {language === 'en' ? 'Language & Region' : 'اللغة والمنطقة'}
              </button>
              <button className="flex items-center px-3 py-2 w-full text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1280">
                <BellIcon size={18} className="mr-3" data-id="element-1281" />
                {language === 'en' ? 'Notifications' : 'الإشعارات'}
              </button>
              <button className="flex items-center px-3 py-2 w-full text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1282">
                <UserIcon size={18} className="mr-3" data-id="element-1283" />
                {language === 'en' ? 'Account' : 'الحساب'}
              </button>
              <button className="flex items-center px-3 py-2 w-full text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1284">
                <ShieldIcon size={18} className="mr-3" data-id="element-1285" />
                {language === 'en' ? 'Security' : 'الأمان'}
              </button>
              <button className="flex items-center px-3 py-2 w-full text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-1286">
                <CreditCardIcon size={18} className="mr-3" data-id="element-1287" />
                {language === 'en' ? 'Billing' : 'الفواتير'}
              </button>
            </nav>
          </div>
          <div className="p-6 col-span-3" data-id="element-1288">
            <div className="space-y-6" data-id="element-1289">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-1290">
                {language === 'en' ? 'Language & Region Settings' : 'إعدادات اللغة والمنطقة'}
              </h3>
              <div className="space-y-4" data-id="element-1291">
                <div data-id="element-1292">
                  <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1293">
                    {language === 'en' ? 'Dashboard Language' : 'لغة لوحة التحكم'}
                  </label>
                  <select id="language" className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-congress-blue-500 focus:border-congress-blue-500 sm:text-sm" data-id="element-1294">
                    <option value="en" selected={language === 'en'} data-id="element-1295">
                      English
                    </option>
                    <option value="ar" selected={language === 'ar'} data-id="element-1296">
                      العربية
                    </option>
                  </select>
                </div>
                <div data-id="element-1297">
                  <label htmlFor="region" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1298">
                    {language === 'en' ? 'Region' : 'المنطقة'}
                  </label>
                  <select id="region" className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-congress-blue-500 focus:border-congress-blue-500 sm:text-sm" data-id="element-1299">
                    <option value="kuwait" data-id="element-1300">Kuwait (الكويت)</option>
                  </select>
                </div>
                <div data-id="element-1301">
                  <label htmlFor="timezone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1302">
                    {language === 'en' ? 'Time Zone' : 'المنطقة الزمنية'}
                  </label>
                  <select id="timezone" className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-congress-blue-500 focus:border-congress-blue-500 sm:text-sm" data-id="element-1303">
                    <option value="ast" data-id="element-1304">
                      (GMT+3:00) Arabia Standard Time - Kuwait
                    </option>
                    <option value="gmt" data-id="element-1305">
                      (GMT+0:00) Greenwich Mean Time - London
                    </option>
                    <option value="est" data-id="element-1306">
                      (GMT-5:00) Eastern Standard Time - New York
                    </option>
                  </select>
                </div>
                <div data-id="element-1307">
                  <label htmlFor="dateFormat" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1308">
                    {language === 'en' ? 'Date Format' : 'تنسيق التاريخ'}
                  </label>
                  <select id="dateFormat" className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-congress-blue-500 focus:border-congress-blue-500 sm:text-sm" data-id="element-1309">
                    <option value="dmy" data-id="element-1310">DD/MM/YYYY</option>
                    <option value="mdy" data-id="element-1311">MM/DD/YYYY</option>
                    <option value="ymd" data-id="element-1312">YYYY/MM/DD</option>
                  </select>
                </div>
                <div data-id="element-1313">
                  <label htmlFor="phoneFormat" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1314">
                    {language === 'en' ? 'Default Phone Code' : 'رمز الهاتف الافتراضي'}
                  </label>
                  <select id="phoneFormat" className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-congress-blue-500 focus:border-congress-blue-500 sm:text-sm" data-id="element-1315">
                    <option value="+965" data-id="element-1316">+965 (Kuwait)</option>
                  </select>
                </div>
                <div className="pt-4" data-id="element-1317">
                  <button type="button" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-congress-blue-600 hover:bg-congress-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-congress-blue-500" data-id="element-1318">
                    <SaveIcon size={16} className="mr-2" data-id="element-1319" />
                    {language === 'en' ? 'Save Changes' : 'حفظ التغييرات'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};